import React, { useEffect, useState } from "react";

const CustomCursor = () => {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [trail, setTrail] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const moveCursor = (e) => setPos({ x: e.clientX, y: e.clientY });

    window.addEventListener("mousemove", moveCursor);
    return () => window.removeEventListener("mousemove", moveCursor);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTrail((prev) => ({
        x: prev.x + (pos.x - prev.x) * 0.2, // Smooth follow effect
        y: prev.y + (pos.y - prev.y) * 0.2,
      }));
    }, 16); // Run every frame (~60fps)

    return () => clearInterval(interval);
  }, [pos]);

  return (
    <>
      {/* Outer Glow Effect */}
      <div
        className="fixed w-16 h-16 bg-blue-500 opacity-20 blur-xl rounded-full pointer-events-none"
        style={{
          left: trail.x,
          top: trail.y,
          transform: "translate(-50%, -50%)",
        }}
      />
      {/* Main Cursor */}
      <div
        className="fixed w-6 h-6 bg-[#f20014] rounded-full pointer-events-none shadow-lg transition-transform"
        style={{
          left: pos.x,
          top: pos.y,
          transform: "translate(-50%, -50%) scale(1.1)",
        }}
      />
    </>
  );
};

export default CustomCursor;
